<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">Configuración</h4>
                    <div class="bg-light configuracion-container">
                        <div v-if="hasConfigAccess">
                            <div class="title-card">
                                <h4 class="mb-2">Desactivación de operaciones</h4>
                            </div>
                            <br>
                            <h5 class=" p-2">Desactivar búsqueda de primas</h5>
                            <div class="row mt-2 p-2">
                                <div class="col-6">
                                    Desactivar automáticamente en el horario (24h):
                                    <div class="mt-2">
                                        <input type="time" v-model="desactivarPrimasHorario" class="form-control">
                                    </div>
                                </div>
                                <div class="col-6 p-2">
                                    Desactivar ahora: <br>
                                    <div class="text-center mt-2">
                                        <input type="checkbox" value="1" v-model="desactivarPrimas" :checked="desactivarPrimas">
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 d-flex justify-content-end">
                                <button class="btn btn-success mt-2 btn-sm btn__guardar" @click="saveconfiguration">Guardar configuración</button>
                            </div>

                            <hr class="my-4">

                            <!-- ====================== LOG DE TRANSACCIONES ====================== -->
                            <div class="title-card">
                                <h4 class="mb-2">Log de transacciones</h4>
                            </div>
                            <div class="log-content p-3">
                            <p class="text-muted mb-2">Últimas transacciones (pagoAttempt) con su detalle de pagos (pagoLog). Expanda una fila para ver el detalle completo.</p>

                            <!-- Filtros -->
                            <div class="row">
                                <div class="col-12 col-md-4 mb-2">
                                    <label class="mb-1">Póliza</label>
                                    <input type="text" v-model="logFiltros.poliza" class="form-control" placeholder="Filtrar por póliza" @keyup.enter="buscarLog">
                                </div>
                                <div class="col-6 col-md-3 mb-2">
                                    <label class="mb-1">Desde</label>
                                    <input type="date" v-model="logFiltros.fechaInicio" class="form-control">
                                </div>
                                <div class="col-6 col-md-3 mb-2">
                                    <label class="mb-1">Hasta</label>
                                    <input type="date" v-model="logFiltros.fechaFin" class="form-control">
                                </div>
                                <div class="col-12 col-md-2 mb-2 d-flex align-items-end">
                                    <button class="btn btn-primary btn-sm w-100 btn__buscarLog" @click="buscarLog" :disabled="cargandoLog">
                                        <i class="fa fa-search" :class="{ 'fa-spin': cargandoLog }"></i> Buscar
                                    </button>
                                </div>
                            </div>
                            <div class="mb-2">
                                <button class="btn btn-link btn-sm px-0" @click="limpiarFiltrosLog">Limpiar filtros</button>
                            </div>

                            <!-- Tabla maestro (pagoAttempt) -->
                            <div class="table-responsive">
                                <table class="table table-sm table-hover table-bordered mb-1">
                                    <thead class="thead-light">
                                        <tr>
                                            <th style="width: 36px;"></th>
                                            <th>ID</th>
                                            <th>Fecha</th>
                                            <th>Usuario</th>
                                            <th>Tipo</th>
                                            <th>Estado</th>
                                            <th class="text-right">Monto</th>
                                            <th>Póliza</th>
                                            <th>Placa</th>
                                            <th>Asegurado</th>
                                            <th>NIT</th>
                                            <th>Trans. Acsel</th>
                                            <th>Origen</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="logAttempts.length > 0">
                                        <template v-for="item in logAttempts" :key="item.id">
                                            <tr>
                                                <td>
                                                    <button class="btn btn-sm btn-outline-secondary py-0 px-1 btn__expandirLog" @click="toggleLogRow(item.id)">
                                                        <i class="fa" :class="logExpanded[item.id] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                                    </button>
                                                </td>
                                                <td>{{ item.id }}</td>
                                                <td>{{ item.createdAt ? dayjs(item.createdAt).format('DD-MM-YYYY HH:mm') : '' }}</td>
                                                <td>{{ item.usuarioEmail }}</td>
                                                <td>{{ item.tipo }}</td>
                                                <td>{{ item.estado }}</td>
                                                <td class="text-right">{{ Numbro(item.monto ? item.monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}</td>
                                                <td>{{ item.poliza }}</td>
                                                <td>{{ item.placa }}</td>
                                                <td>{{ item.nombreAsegurado }}</td>
                                                <td>{{ item.nitAsegurado }}</td>
                                                <td>{{ item.transaccionAcsel }}</td>
                                                <td>{{ item.origin }}</td>
                                            </tr>
                                            <tr v-if="logExpanded[item.id]">
                                                <td colspan="13" class="bg-light p-2">
                                                    <h6 class="font-weight-bold">Detalle pagoAttempt #{{ item.id }}</h6>
                                                    <div class="row small">
                                                        <div class="col-12 col-md-4"><b>Requerimiento:</b> {{ item.requerimiento }}</div>
                                                        <div class="col-12 col-md-4"><b>Reclamo:</b> {{ item.reclamo }}</div>
                                                        <div class="col-12 col-md-4"><b>Reclamo ramo:</b> {{ item.reclamoRamo }}</div>
                                                        <div class="col-12 col-md-4"><b>Dirección:</b> {{ item.direccionAsegurado }}</div>
                                                        <div class="col-12 col-md-4"><b>Recobro:</b> {{ item.recobro }}</div>
                                                        <div class="col-12 col-md-4"><b>Recobro no pago:</b> {{ item.recobroNoPago }}</div>
                                                        <div class="col-12 col-md-4"><b>Fecha reversa:</b> {{ item.fechaReversa }}</div>
                                                        <div class="col-12 col-md-4"><b>Only F:</b> {{ item.onlyF }}</div>
                                                        <div class="col-12 col-md-4"><b>Actualizado:</b> {{ item.updatedAt }}</div>
                                                        <div class="col-12"><b>Descripción estado:</b> {{ item.estadoDescripcion }}</div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <details v-if="item.dataSearch" class="mb-1"><summary>dataSearch</summary><pre class="log-pre">{{ item.dataSearch }}</pre></details>
                                                        <details v-if="item.sendToAcsel" class="mb-1"><summary>sendToAcsel</summary><pre class="log-pre">{{ item.sendToAcsel }}</pre></details>
                                                        <details v-if="item.dataResponse" class="mb-1"><summary>dataResponse</summary><pre class="log-pre">{{ item.dataResponse }}</pre></details>
                                                    </div>

                                                    <h6 class="font-weight-bold mt-3">Pagos (pagoLog): {{ item.log ? item.log.length : 0 }}</h6>
                                                    <div class="table-responsive" v-if="item.log && item.log.length > 0">
                                                        <table class="table table-sm table-bordered bg-white mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th><th>Tipo</th><th class="text-right">Monto</th><th>Nombre</th><th>Email</th><th>Teléfono</th>
                                                                    <th>Estado</th><th>Autorización</th><th>Referencia</th><th>Llave req.</th><th>No. cheque</th>
                                                                    <th>Entidad fin.</th><th>Trans. Acsel</th><th>Audit</th><th>Origen</th><th>Cuotas</th><th>From POS</th>
                                                                    <th>Fecha</th><th>Fecha reversa</th><th>Descripción</th><th>JSON</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="pago in item.log" :key="pago.id">
                                                                    <td>{{ pago.id }}</td>
                                                                    <td>{{ pago.type }}</td>
                                                                    <td class="text-right">{{ Numbro(pago.monto ? pago.monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}</td>
                                                                    <td>{{ pago.nombre }}</td>
                                                                    <td>{{ pago.email }}</td>
                                                                    <td>{{ pago.telefono }}</td>
                                                                    <td>{{ pago.estado }}</td>
                                                                    <td>{{ pago.autorizacionPagoTarjeta }}</td>
                                                                    <td>{{ pago.referenciaPagoTarjeta }}</td>
                                                                    <td>{{ pago.llaveRequerimiento }}</td>
                                                                    <td>{{ pago.noCheque }}</td>
                                                                    <td>{{ pago.entidadFinanciera }}</td>
                                                                    <td>{{ pago.transaccionAcsel }}</td>
                                                                    <td>{{ pago.auditNumber }}</td>
                                                                    <td>{{ pago.origin }}</td>
                                                                    <td>{{ pago.cuotas }}</td>
                                                                    <td>{{ pago.fromPOS }}</td>
                                                                    <td>{{ pago.createdAt ? dayjs(pago.createdAt).format('DD-MM-YYYY HH:mm') : '' }}</td>
                                                                    <td>{{ pago.fechaReversa }}</td>
                                                                    <td>{{ pago.estadoDescripcion }}</td>
                                                                    <td>
                                                                        <details v-if="pago.dataResponse" class="mb-1"><summary>response</summary><pre class="log-pre">{{ pago.dataResponse }}</pre></details>
                                                                        <details v-if="pago.sendToAcsel" class="mb-1"><summary>sendToAcsel</summary><pre class="log-pre">{{ pago.sendToAcsel }}</pre></details>
                                                                        <details v-if="pago.reversaLog" class="mb-1"><summary>reversaLog</summary><pre class="log-pre">{{ pago.reversaLog }}</pre></details>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div v-else class="text-muted small">Sin registros de pago.</div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr><td colspan="13" class="text-center text-muted">No se encontraron transacciones</td></tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Paginación -->
                            <div class="d-flex justify-content-between align-items-center" v-if="logTotal > 0">
                                <small class="text-muted">Total: {{ logTotal }} — Página {{ logPage }} de {{ logTotalPages }}</small>
                                <div>
                                    <button class="btn btn-sm btn-outline-secondary mr-1 btn__logPrev" @click="cambiarPaginaLog(logPage - 1)" :disabled="logPage <= 1 || cargandoLog">Anterior</button>
                                    <button class="btn btn-sm btn-outline-secondary btn__logNext" @click="cambiarPaginaLog(logPage + 1)" :disabled="logPage >= logTotalPages || cargandoLog">Siguiente</button>
                                </div>
                            </div>
                            </div>
                            <!-- ==================== FIN LOG DE TRANSACCIONES ==================== -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";
import API from "src/core/Api";
import {store} from "src/store";
import dayjs from "dayjs";
import Numbro from "numbro";
import Tools from "src/core/Tools";


export default {
    props: {
    },
    components: {
        //TimelineChart,
        Layout,
        //Toster,
    },
    data(){
        return  {
            config: {},
            hasConfigAccess: false,
            desactivarPrimasHorario: "",
            desactivarPrimas: 0,
            // Log de transacciones
            logAttempts: [],
            logFiltros: { poliza: "", fechaInicio: "", fechaFin: "" },
            logPage: 1,
            logLimit: 15,
            logTotal: 0,
            cargandoLog: false,
            logExpanded: {},
        }
    },
    computed: {
        logTotalPages() {
            return Math.max(1, Math.ceil(this.logTotal / this.logLimit));
        }
    },
    mounted() {
        this.hasConfigAccess = Tools.checkAccess('configuracion/pos');
        this.getConfig();
        if (this.hasConfigAccess) {
            this.getLogTransacciones();
        }
    },
    methods: {
        Numbro,
        dayjs,
        getLogTransacciones() {
            const self = this;

            if (self.cargandoLog) {
                return;
            }
            self.cargandoLog = true;

            API.send('POST', 'configuracion/log-transacciones', {
                    poliza: self.logFiltros.poliza,
                    fechaInicio: self.logFiltros.fechaInicio,
                    fechaFin: self.logFiltros.fechaFin,
                    page: self.logPage,
                    limit: self.logLimit,
                },
                function (response) {
                    store.dispatch('coreHideLoading');
                    if (response.status) {
                        self.logAttempts = Array.isArray(response.data) ? response.data : [];
                        self.logTotal = response.total || 0;
                    }
                    else {
                        self.logAttempts = [];
                        self.logTotal = 0;
                    }
                    self.logExpanded = {};
                    self.cargandoLog = false;
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.cargandoLog = false;
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
        },
        buscarLog() {
            this.logPage = 1;
            this.getLogTransacciones();
        },
        limpiarFiltrosLog() {
            this.logFiltros = { poliza: "", fechaInicio: "", fechaFin: "" };
            this.logPage = 1;
            this.getLogTransacciones();
        },
        cambiarPaginaLog(page) {
            if (page < 1 || page > this.logTotalPages) {
                return;
            }
            this.logPage = page;
            this.getLogTransacciones();
        },
        toggleLogRow(id) {
            this.logExpanded[id] = !this.logExpanded[id];
        },
        generateReport(typeReport) {
            const self = this;
            API.send('GET', "report/" + typeReport + "/" + this.dateStart + "/" + this.dateEnd + '/' + self.userSelect, false,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/rpt/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
            //window.open(CONFIG.getWsUrl());
        },
        getConfig() {
            const self = this;
            API.send('POST', "configuracion/get-config", false,
                function (response) {
                    store.dispatch('coreHideLoading');

                    self.config = response.data;

                    self.desactivarPrimasHorario = response.data.desactivarPrimasHorario;
                    self.desactivarPrimas = response.data.desactivarPrimas;
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
        },
        saveconfiguration() {
            const self = this;
            API.send('POST', "configuracion/disable-primas", {
                    desactivarPrimas: self.desactivarPrimas,
                    desactivarPrimasHorario: self.desactivarPrimasHorario,
                },
                function (response) {
                    store.dispatch('coreHideLoading');
                },
                function () {
                    store.dispatch('coreHideLoading');
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                })
        },
        /*visanet() {
            const test = new AndroidBridge();
            test.VisanetPayApp();
        }*/
    }
};
</script>

<style scoped>
.log-pre {
    max-height: 200px;
    overflow: auto;
    background: #fff;
    border: 1px solid #eee;
    padding: 6px;
    margin: 4px 0 0;
    font-size: 11px;
    white-space: pre-wrap;
    word-break: break-all;
}
.log-pre,
details summary {
    cursor: pointer;
}
details summary {
    font-size: 12px;
    color: #007bff;
}
</style>
